import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}));
const ActionButton = styled(Button)(() => ({
    width: '100%',
}));
const Actions = ({ nextLabel = 'Next', previousLabel = 'Previous', completeLabel = 'Complete', steps, step = 0, isNextDisabled = false, handleNext, handlePrevious, handleComplete, }) => {
    return (_jsxs(Root, { children: [handleNext && step + 1 < steps.length && (_jsx(ActionButton, Object.assign({ "data-qa": "next-step", variant: "contained", color: "primary", onClick: steps[step].handleNext || handleNext, disabled: isNextDisabled }, { children: steps[step].nextLabel || nextLabel }))), handleComplete && step + 1 === steps.length && (_jsx(ActionButton, Object.assign({ "data-qa": "complete-step", variant: "contained", color: "primary", onClick: handleComplete }, { children: completeLabel }))), handlePrevious && step > 0 && (_jsx(ActionButton, Object.assign({ "data-qa": "previous-step", variant: "outlined", color: "primary", onClick: handlePrevious }, { children: previousLabel })))] }));
};
export default Actions;
//# sourceMappingURL=actions.js.map